import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./dialog";
import { Button } from "./button";
import styles from "./closeCellModal.module.scss";

interface CloseCellModalProps {
  orderNumber: string;
  message?: string;
  isOpen: boolean;
  onClose: () => void;
}

export function CloseCellModal({ orderNumber, message, isOpen, onClose }: CloseCellModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent className={styles.content}>
        <DialogHeader>
          <DialogTitle className={styles.title}>Закройте ячейку</DialogTitle>
          <DialogDescription className={styles.description}>
            {message || `Пожалуйста, закройте ячейку для заказа ${orderNumber}. Только после этого мы приостановим списание средств за хранение и заказ будет считаться выполненным.`}
          </DialogDescription>
        </DialogHeader>
        <div className={styles.actions}>
          <Button onClick={onClose} className={styles.closeButton}>
            Понятно
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
